<template>
  <portlet
          :icon="'fad fa-users'"
          :title="'Gebruiker aanmaken'"
          :actionsBlock="true"
          :footer="true"
  >
    <template slot="actionsBlock">
      <router-link tag="button" :to="{name:'users'}" class="btn btn-secondary">
        <i class="fas fa-long-arrow-left mr-2"></i>
        Terug
      </router-link>
    </template>

    <template slot="portletBody">
      <form action>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
              <label :for="name+'-email'">Email</label>
              <input v-validate="'required|email'" 
                      :name="name+'-email'"
                      :id="name+'-email'"
                      type="text"
                      class="form-control"
                      v-model="email">
          </div>
          <div class="form-group">
              <label :for="name+'-password'">Wachtwoord</label>
              <input v-validate="'required'"
                      :name="name+'-password'"
                      :id="name+'-password'"
                      type="password"
                      class="form-control"
                      v-model="password">
          </div>
          <div class="form-group">
              <label :for="name+'-fistname'">Voornaam</label>
              <input v-validate="'required'"
                      :name="name+'-fistname'"
                      :id="name+'-fistname'"
                      type="text"
                      class="form-control"
                      v-model="firstname">
          </div>
          <div class="form-group">
              <label :for="name+'-lastname'">Achternaam</label>
              <input v-validate="'required'"
                      :name="name+'-lastname'"
                      :id="name+'-lastname'"
                      type="text"
                      class="form-control"
                      v-model="lastname">
          </div>
          <div class="form-group">
              <label :for="name+'-mobile'">Mobiel</label>
              <input  v-validate="'required'"
                      :name="name+'-mobile'"
                      :id="name+'-mobile'"
                      type="text"
                      class="form-control"
                      v-model="mobile">
          </div>
          <div class="form-group">
            <vue-multi-select
                    ref="multiSelect"
                    v-validate="'required'"
                    v-model="departments"
                    :options="options"
                    :filters="filters"
                    :btnLabel="btnLabel"
                    :selectOptions="selectOptions"
                >
                <template v-slot:option="{option}">
                    <input type="checkbox" :checked="option.selected"/>
                    <span>{{option.name}}</span>
                </template>
            </vue-multi-select>
          </div>

          <div class="form-group" v-for="d in departments" :key="d.name">
              <label :for="name+'-role'">{{d.name}} Role</label>
              <select v-model="roles[d.name]" class="form-control">
                  <option disabled value="">Selecteer..</option>
                  <option v-for="role in getRoles.filter((r) => r.department === d.name)"  :value="role.id" :key="role.id">
                      {{role !== undefined ? role.name : ''}}
                  </option>
              </select>
          </div></div>
        <div class="col-6 d-flex flex-column">

        <div class="  upload-image-file  flex-fill">
            <picture-input
                ref="pictureInput"
                :crop="false"
                width="300"
                height="300"
                margin="16"
                accept="image/*"
                size="10"
                removeButtonClass="btn btn-dark btn-block"
                :hideChangeButton="true"
                :removable="true"
                :custom-strings="{
                upload: '📷 Upload profielfoto',
                drag: '📷 Upload profielfoto',
                tap: '📷 Upload profielfoto',
                change: 'Pas profielfoto aan',
                remove: '🗑️ Verwijder profielfoto'
              }"
                @change="handleProfileFileChange">
            </picture-input>
            <div class="ha_role_picker">
                <h4>Hour app role</h4>
                <input id="ha_null" type="radio" name="hourAppRole" v-model="hourAppRole" v-bind:value="null" selected/> <label for="ha_null">Don't create</label>
                <input id="ha_admin" type="radio" name="hourAppRole" v-model="hourAppRole" value="admin" /> <label for="ha_admin">Admin</label>
                <input id="ha_locm" type="radio" name="hourAppRole" v-model="hourAppRole" value="location_manager" /> <label for="ha_locm">Location Manager</label>
                <input id="ha_accm" type="radio" name="hourAppRole" v-model="hourAppRole" value="account_manager" /> <label for="ha_accm">Account Manager</label>
                <input id="ha_client" type="radio" name="hourAppRole" v-model="hourAppRole" value="client" /> <label for="ha_client">Client</label>
            </div>
            <div v-if="hourAppRole">
                <select id="organization_select" name="organization_select" v-validate="{required: companyRequired}" v-model="selectedOrg">
                    <option v-if="!companyRequired" v-bind:value="null">Geen bedrijf</option>
                    <option v-for="org, i in getCustomers" v-bind:key="i" v-bind:value="org">
                        {{ org.name }}
                    </option>
                </select>
                <span v-if="errors.first('organization_select')" class="small text-danger d-block">Kies het bedrijf waar deze klant bij hoort.</span>
            </div>
          </div>
        </div>
      </div>
      </form>
    </template>
    <div slot="portletFooter" class="col text-right">
      <button @click="addUser" type="submit" class="btn btn-primary">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import store from '../../store.js';
  import Vue from 'vue';
  import { DEPARTMENTS } from '../../constants.js';
  import vueMultiSelect from 'vue-multi-select';
  import 'vue-multi-select/dist/lib/vue-multi-select.css';
  import { imageOrientation } from '../../components/mixins/imageOrientation.js';
  import { describeHourAppSyncOutcome } from '@/utils/placementSync';
  import { buildNewUserHourAppPayload, hourAppRoleRequiresCompany } from '@/utils/userSync';

  const departmentOptions = DEPARTMENTS.map(d => {return {name: d}})
  
  export default {
    mixins: [imageOrientation],
    data() {
      return {
        btnLabel: values => `Departments selected (${values.length})`,
        selectOptions: departmentOptions,
        filters: [
            {
                nameAll: 'Selecteer alles',
                nameNotAll: 'Deselecteer alles',
                func() {
                    return true;
                },
            },
        ],
        name: "user",
        options: {
            multi: true,
        },
        firstname: null,
        lastname: null,
        email: null,
        password: null,
        roles: {},
        departments: [],
        mobile: null,
        profilePicture: {
          profilePicture: true,
          name: 'profilepicture',
          file: null,
        },
        hourAppRole: null,
        selectedOrg: null
      };
    },
    methods: {
      triggerImageUpload() {
        this.$refs.pictureInput.$refs.fileInput.click();
      },
      handleProfileFileChange() {
        this.$store.commit('setLoading', true)
        this.profilePicture.file = this.$refs.pictureInput.file
        let file = this.profilePicture.file
        let ImgCheck = this.$refs.pictureInput
         ImgCheck.getEXIFOrientation(file, (orientation) => {
             var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              var base64 = reader.result;
              this.resetOrientation(base64, orientation, (resetBase64Image) => {
                let newFile = this.dataURItoBlob(resetBase64Image);
                this.profilePicture.file = newFile
                this.$store.commit('setLoading', false)
              });
            }
          }
        )
      },
      addUser() {
        this.$validator.validate().then(result => {
          if(result) {
            var newUser = { 
              firstname: this.firstname,
              lastname: this.lastname,
              email: this.email,
              password: this.password,
              roles: this.roles,
              departments: this.departments,
              mobile: this.mobile,
            }
            console.log(newUser)
            
            store.dispatch('users/postUser', {ApiClient: Vue.prototype.$ApiClient, user: newUser}).then((res) => {
             
              this.profilePicture.name = res.data.UserId
              let docRef = res.data.UserId

              let documentArray = []
              if (this.profilePicture.file) {
                documentArray.push(this.profilePicture)
              }
              _.each(documentArray, (doc) => {
                doc.path = '/user_pictures/' + docRef + '/';
              });
              this.$FB_UPLOADER.upload(documentArray).then(res => {
                console.log(res)
              })

              var hourAppUser = buildNewUserHourAppPayload({
                user: newUser,
                hourAppRole: this.hourAppRole,
                firebaseId: docRef,
                company: this.selectedOrg,
              })
              if (hourAppUser) {
                store.dispatch('users/postUserHourApp', {ApiClient: Vue.prototype.$ApiClient, user: hourAppUser, role: this.hourAppRole})
                .then((res) => {
                  const outcome = describeHourAppSyncOutcome(res);

                  // The portal user is created either way, so "Gebruiker aangemaakt" stays true. What
                  // it never said is whether the urenapp half landed, and a refusal there leaves the
                  // company without the contact person this screen was used to give it.
                  if (!outcome.ok) {
                    this.$toasted.global.failedRequest({message: 'Urenapp: ' + outcome.message});
                  }
                })
              }

              this.$router.push('/users');

              this.$toasted.global.successRequest({
                message: 'Gebruiker aangemaakt'
              });

              this.role = {};
            }).catch((err) => {
              this.$toasted.global.failedRequest();
              console.log(err);
            });
          } else {
            this.$toasted.global.failedFormRequest();
          }
        });
      }
    },
    
    computed: {
      ...mapGetters('roles', ['getRoles']),
      ...mapGetters('customers', ['getCustomers','getCustomersDataTable']),
      companyRequired() {
        return hourAppRoleRequiresCompany(this.hourAppRole);
      },
    },
    watch: {
      role: {
        handler: function (val, oldV) {
          if(JSON.stringify(val) !== JSON.stringify(this.roleCopy)) {
            this.disableNavigation = true;
          }
        },
        deep: true
      },
    },
    components: {
      vueMultiSelect,
    },
  };
</script>

<style lang="scss" scoped>
.ha_role_picker {
    label {
        margin-left: 5px;
        font-weight: 400;
        margin-top: 5px;
        margin-right: 5px;
    }
    h5 {
        font-size: 1.5rem;
        font-weight: 600;
        margin-bottom: 2rem;
    }

    input[type="checkbox"],input[type="radio"] {
        accent-color: #146F70;
        vertical-align: middle;
        
    }
    h4 {
        margin-top: 2rem;
        margin-bottom: 1rem;
    }
}
</style>